var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$vuetify.theme.dark ? 'darkBackground' : 'lightBackground'},[_c('AppToolbarVue'),_c('AppDrawerVue'),_c('v-main',[_c('v-theme-provider',{attrs:{"root":""}},[_c('v-slide-y-reverse-transition',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]})],1)],1)],1),_c('AppFooterVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }